import {ReportLegendColorsEnum} from 'common/proxies/enum-proxy';

const colorScales = {
  [ReportLegendColorsEnum.GREEN_YELLOW_RED.id]: [
    '#075100',
    '#0b8500',
    '#bedf3f',
    '#fff300',
    '#ffc300',
    '#ff0000',
  ],
  [ReportLegendColorsEnum.RED_YELLOW_GREEN.id]: [
    '#ff0000',
    '#ffc300',
    '#fff300',
    '#bedf3f',
    '#0b8500',
    '#075100',
  ],
  [ReportLegendColorsEnum.BLUE_PURPLE_RED.id]: [
    '#126B96',
    '#3AA9DF',
    '#9781E2',
    '#C7BBED',
    '#F15F4B',
    '#C73724',
  ],
  [ReportLegendColorsEnum.RED_PURPLE_BLUE.id]: [
    '#C73724',
    '#F15F4B',
    '#C7BBED',
    '#9781E2',
    '#3AA9DF',
    '#126B96',
  ],
  [ReportLegendColorsEnum.GREEN_RED.id]: [
    '#075100',
    '#0b8500',
    '#bedf3f',
    '#FF978A',
    '#C73724',
    '#571810',
  ],
  [ReportLegendColorsEnum.RED_GREEN.id]: [
    '#571810',
    '#C73724',
    '#FF978A',
    '#bedf3f',
    '#0b8500',
    '#075100',
  ],
  [ReportLegendColorsEnum.BLUE_RED.id]: [
    '#09374D',
    '#3AA9DF',
    '#CBEBFA',
    '#FF978A',
    '#F15F4B',
    '#91281A',
  ],
  [ReportLegendColorsEnum.RED_BLUE.id]: [
    '#91281A',
    '#F15F4B',
    '#FF978A',
    '#CBEBFA',
    '#3AA9DF',
    '#09374D',
  ],
  [ReportLegendColorsEnum.GREEN_DARK_LIGHT.id]: [
    '#244000',
    '#447A00',
    '#6BA819',
    '#8BC53F',
    '#B0D67E',
    '#DBEBC5',
  ],
  [ReportLegendColorsEnum.GREEN_LIGHT_DARK.id]: [
    '#DBEBC5',
    '#B0D67E',
    '#8BC53F',
    '#6BA819',
    '#447A00',
    '#244000',
  ],
  [ReportLegendColorsEnum.RED_DARK_LIGHT.id]: [
    '#571810',
    '#91281A',
    '#C73724',
    '#F15F4B',
    '#FF978A',
    '#FFC5BC',
  ],
  [ReportLegendColorsEnum.RED_LIGHT_DARK.id]: [
    '#FFC5BC',
    '#FF978A',
    '#F15F4B',
    '#C73724',
    '#91281A',
    '#571810',
  ],
  [ReportLegendColorsEnum.BLUE_DARK_LIGHT.id]: [
    '#09374D',
    '#126B96',
    '#3397C7',
    '#3AA9DF',
    '#8ECDED',
    '#CBEBFA',
  ],
  [ReportLegendColorsEnum.BLUE_LIGHT_DARK.id]: [
    '#CBEBFA',
    '#8ECDED',
    '#3AA9DF',
    '#3397C7',
    '#126B96',
    '#09374D',
  ],
};

export const DEFAULT_COLOR_SCALE =
  colorScales[ReportLegendColorsEnum.GREEN_YELLOW_RED.id];

export default colorScales;
